import { murmur3 } from 'murmurhash-js';

/**
 * 메이플랩스 디자인 해시 생성
 * @param data - [number, string] 형태의 데이터 배열
 * @returns 16진수 해시 문자열
 * @throws {Error} 데이터 형식이 잘못된 경우
 */
export function getMapleLabsDesignHash(data: [number, string][]): string {
  const MAPLE_LABS_SEED = 0x4d ^ 0x41 ^ 0x50 ^ 0x4c ^ 0x45 ^ 0x5f ^ 0x4c ^ 0x41 ^ 0x42 ^ 0x53;

  // 중복 제거 -> 정렬 -> 합치기 -> 해싱
  const uniqueSortedStr = Array.from(new Set(data.map(([num, str]) => `${num}:${str}`)))
    .sort((a, b) => {
      const [num1, str1] = a.split(':');
      const [num2, str2] = b.split(':');

      if (!num1 || !str1 || !num2 || !str2) {
        throw new Error('데이터 형식이 잘못되었습니다. 숫자와 문자열이 모두 있어야 합니다.');
      }

      const numCompare = parseInt(num1) - parseInt(num2);
      if (numCompare !== 0) return numCompare;
      return str1.localeCompare(str2);
    })
    .join('|');

  return murmur3(uniqueSortedStr, MAPLE_LABS_SEED).toString(16);
}
